export default __webpack_public_path__ + "static/media/club.b769f2b1.jfif";